import { Pipe, PipeTransform } from '@angular/core';
import { FundProductPricesEnum } from '@spa/api';
import { Helper } from '../classes';
import { LanguageService } from '../language.service';

@Pipe({
  name: 'priceType',
  pure: true
})
export class PriceTypePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(value: FundProductPricesEnum): string {
    const language = this.languageService.getCurrentLanguage();

    return Helper.textsHelper().getPriceTypeName(value, language);
  }
}
